import MutationTypes from '@/admin/deployments/store/MutationTypes';

export default {
  [MutationTypes.setDeployments](state, deployments) {
    state.deployments = deployments;
    state.userEditStaticDataFetched = true;
  },
};
